var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(!_vm.privacyAndTermsToSignUpFields)?_c('terms-and-privacy-c',{attrs:{"siteData":_vm.siteData}}):_vm._e(),(_vm.privacyAndTermsToSignUpFields)?_c('sign-up-fields-c'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }